import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

function AdminAuth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Check if user is already authenticated and has admin privileges
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult();
          if (idTokenResult.claims && idTokenResult.claims.admin) {
            // User is already logged in and has admin privileges
            navigate('/adminpfy9665k01');
          }
        } catch (error) {
          console.error('Error checking admin status:', error);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      if (!email || !password) {
        setError("Please enter email and password.");
        setLoading(false);
        return;
      }
      
      await signInWithEmailAndPassword(auth, email, password);
      setLoading(false);
      navigate('/adminpfy9665k01');
    } catch (err) {
      setLoading(false);
      setError(err.message.replace('Firebase: ', ''));
    }
  };



  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{ 
        background: '#fff', 
        borderRadius: '16px', 
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)', 
        padding: '3rem 2.5rem', 
        minWidth: 400,
        maxWidth: 500,
        width: '100%'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ 
            fontSize: '3rem', 
            marginBottom: '1rem',
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))'
          }}>
            🚗
          </div>
          <h1 style={{ 
            color: '#1f2937', 
            fontWeight: 'bold', 
            fontSize: '1.8rem',
            marginBottom: '0.5rem'
          }}>
            Rocket Express Auto Wash TT
          </h1>
          <p style={{ 
            color: '#6b7280', 
            fontSize: '1.1rem',
            fontWeight: '500'
          }}>
            Admin Panel Access
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ 
              display: 'block', 
              color: '#374151', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '0.95rem'
            }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '1rem', 
                borderRadius: '12px', 
                border: '2px solid #e5e7eb',
                fontSize: '1rem',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#f97316';
                e.target.style.boxShadow = '0 0 0 3px rgba(249, 115, 22, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.boxShadow = 'none';
              }}
              autoComplete="username"
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{ 
              display: 'block', 
              color: '#374151', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '0.95rem'
            }}>
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ 
                  width: '100%', 
                  padding: '1rem', 
                  paddingRight: '3rem',
                  borderRadius: '12px', 
                  border: '2px solid #e5e7eb',
                  fontSize: '1rem',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#f97316';
                  e.target.style.boxShadow = '0 0 0 3px rgba(249, 115, 22, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e5e7eb';
                  e.target.style.boxShadow = 'none';
                }}
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '1.2rem',
                  color: '#9ca3af',
                  padding: '0.25rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '24px',
                  height: '24px'
                }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "🔒" : "👁️"}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ 
              background: '#fef2f2', 
              border: '1px solid #fecaca', 
              color: '#dc2626', 
              padding: '1rem', 
              borderRadius: '8px', 
              marginBottom: '1.5rem',
              fontSize: '0.95rem',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            disabled={loading}
            style={{ 
              width: '100%', 
              background: '#f97316', 
              color: '#fff', 
              border: 'none', 
              borderRadius: '12px', 
              padding: '1rem', 
              fontWeight: 'bold', 
              fontSize: '1.1rem', 
              cursor: loading ? 'not-allowed' : 'pointer',
              marginBottom: '1rem',
              transition: 'all 0.2s',
              opacity: loading ? 0.7 : 1
            }}
            onMouseOver={(e) => {
              if (!loading) {
                e.target.style.background = '#ea580c';
                e.target.style.transform = 'translateY(-2px)';
              }
            }}
            onMouseOut={(e) => {
              if (!loading) {
                e.target.style.background = '#f97316';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {loading ? 'Signing In...' : 'Sign In to Admin Panel'}
          </button>
        </form>

        <div style={{ 
          textAlign: 'center', 
          marginTop: '2rem', 
          padding: '1.5rem',
          background: '#f9fafb',
          borderRadius: '12px',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ 
            color: '#6b7280', 
            fontSize: '0.9rem',
            lineHeight: '1.5'
          }}>
            <strong>🔒 Admin Access Only</strong><br />
            This page is restricted to authorized administrators only.
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminAuth;
